<template>
  <svg
    width="360"
    height="360"
    viewBox="0 0 360 360"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M177.283 53C147.491 53 120.108 63.3272 98.4867 80.6055H63.5425C59.0026 80.6055 55.288 84.3323 55.288 88.8872C55.288 93.4421 59.0026 97.1688 63.5425 97.1688H81.3267H86.538C91.078 97.1688 94.7926 100.896 94.7926 105.45C94.7926 107.725 93.8626 109.801 92.3657 111.297C90.8744 112.799 88.8053 113.732 86.538 113.732H75.4197H69.2806H39.3292C34.7892 113.732 31.0747 117.459 31.0747 122.014C31.0747 126.569 34.7892 130.295 39.3292 130.295H60.7712C54.2986 145.557 50.7133 162.349 50.7133 179.985C50.7133 186.384 51.1866 192.673 52.0946 198.818C52.4743 201.385 52.9311 203.93 53.4649 206.448C69.0384 204.057 85.5585 202.136 102.805 200.734L104.104 201.921L105.325 200.535C126.044 198.917 147.792 198.056 170.223 198.056C217.879 198.056 262.475 201.943 300.606 208.701C302.075 202.307 303.066 195.732 303.533 189.007C303.748 186.025 303.852 183.016 303.852 179.985C303.852 109.851 247.188 53 177.283 53Z"
      fill="#F1F2F7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.264 113.349H9.2615C4.66262 113.349 0.899902 117.151 0.899902 121.798C0.899902 126.444 4.66262 130.246 9.2615 130.246H14.264C18.8628 130.246 22.6256 126.444 22.6256 121.798C22.6256 117.151 18.8628 113.349 14.264 113.349Z"
      fill="#F1F2F7"
    />
    <mask
      id="mask0_16930_595"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="53"
      y="198"
      width="274"
      height="109"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M326.699 198.238V306.466H189.996H53.2925V198.238H326.699Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_16930_595)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M326.7 240.082C326.7 244.608 322.986 248.312 318.447 248.312H265.735C263.468 248.312 261.4 249.239 259.909 250.731C258.412 252.218 257.482 254.281 257.482 256.541C257.482 261.067 261.196 264.77 265.735 264.77H275.528C277.794 264.77 279.864 265.698 281.355 267.19C282.851 268.677 283.781 270.739 283.781 273C283.781 277.526 280.067 281.229 275.528 281.229H253.01C231.855 297.074 205.569 306.466 177.081 306.466C116.237 306.466 65.4237 263.646 53.2925 206.577C68.8623 204.202 85.3784 202.293 102.621 200.899L103.919 202.079L105.141 200.702C125.854 199.094 147.597 198.238 170.022 198.238C217.666 198.238 262.252 202.101 300.373 208.816C298.52 216.815 295.901 224.518 292.6 231.853H318.447C320.719 231.853 322.777 232.78 324.273 234.272C325.77 235.759 326.7 237.822 326.7 240.082Z"
        fill="#E8EBF2"
      />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M302.646 188.631C302.178 195.484 301.189 202.185 299.722 208.701C261.642 201.814 217.105 197.854 169.512 197.854C147.111 197.854 125.392 198.731 104.701 200.379L119.05 183.753L141.372 198.32L171.589 189.977L223.571 197.854L246.139 189.977L251.854 197.854L265.491 187.732L278.234 199.412L298.331 183.354L302.646 188.631Z"
      fill="#E0E2EE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M162.257 148.86C165.7 143.856 167.672 137.922 167.621 131.571C167.48 113.907 151.744 99.7127 132.474 99.8665C113.203 100.021 97.6963 114.465 97.8374 132.129C97.9785 149.793 113.715 163.988 132.985 163.834C139.87 163.779 146.274 161.899 151.656 158.7L166.053 162.09L162.257 148.86Z"
      fill="#D8DBEA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M122.553 131.095C122.569 133.102 120.955 134.742 118.948 134.758C116.94 134.774 115.299 133.16 115.284 131.153C115.268 129.145 116.882 127.505 118.889 127.489C120.896 127.473 122.537 129.087 122.553 131.095Z"
      fill="#BEC0D6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M135.637 131.095C135.653 133.102 134.039 134.742 132.031 134.758C130.024 134.774 128.383 133.16 128.368 131.153C128.351 129.146 129.966 127.505 131.973 127.489C133.98 127.473 135.621 129.088 135.637 131.095Z"
      fill="#BEC0D6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M148.722 131.095C148.738 133.102 147.124 134.742 145.116 134.758C143.109 134.774 141.468 133.16 141.453 131.153C141.436 129.145 143.051 127.505 145.058 127.489C147.065 127.473 148.706 129.088 148.722 131.095Z"
      fill="#BEC0D6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M104.7 200.251L103.529 201.458L102.286 200.425C103.087 200.362 103.894 200.304 104.7 200.251Z"
      fill="#F1F2F7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M115.563 208.7C115.563 212.533 116.789 216.101 118.895 219.105L116.66 227.118L125.365 225C128.638 226.904 132.519 228.012 136.685 228.012C148.351 228.012 157.807 219.365 157.807 208.7C157.807 198.034 148.351 189.388 136.685 189.388C125.019 189.388 115.563 198.034 115.563 208.7Z"
      fill="url(#paint0_linear_16930_595)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M142.117 208.701C142.117 210.034 143.197 211.115 144.531 211.115C145.864 211.115 146.945 210.034 146.945 208.701C146.945 207.368 145.864 206.287 144.531 206.287C143.197 206.287 142.117 207.368 142.117 208.701Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M134.875 208.701C134.875 210.034 135.956 211.115 137.289 211.115C138.622 211.115 139.703 210.034 139.703 208.701C139.703 207.368 138.622 206.287 137.289 206.287C135.956 206.287 134.875 207.368 134.875 208.701Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M126.426 208.701C126.426 210.034 127.507 211.115 128.84 211.115C130.173 211.115 131.254 210.034 131.254 208.701C131.254 207.368 130.173 206.287 128.84 206.287C127.507 206.287 126.426 207.368 126.426 208.701Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M102.286 200.563C85.0453 201.968 68.5308 203.892 52.9626 206.286C52.429 203.765 51.9724 201.215 51.5928 198.644L78.2784 178.526L102.286 200.563Z"
      fill="#E0E2EE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M222.984 241.893C222.984 244.226 201.909 246.117 175.912 246.117C149.914 246.117 128.84 244.226 128.84 241.893C128.84 239.56 149.914 237.668 175.912 237.668C201.909 237.668 222.984 239.56 222.984 241.893Z"
      fill="#D8DBEA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M300.231 281.119C295.584 281.119 291.782 277.317 291.782 272.67C291.782 268.023 295.584 264.221 300.231 264.221C304.878 264.221 308.68 268.023 308.68 272.67C308.68 277.317 304.878 281.119 300.231 281.119Z"
      fill="#E1E3EF"
    />
    <mask
      id="mask1_16930_595"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="50"
      y="51"
      width="254"
      height="255"
    >
      <ellipse
        cx="176.659"
        cy="178.265"
        rx="126.659"
        ry="127.265"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask1_16930_595)">
      <g clip-path="url(#clip0_16930_595)">
        <path
          d="M163.683 274.532L232.986 296.921C237.105 302.51 246.133 304.531 256.625 305.489L205.071 312.246L148.799 290.174L156.394 274.638L163.683 274.522V274.532Z"
          fill="#BEC0D6"
        />
        <path
          d="M310.547 198.853C300.54 166.76 282.085 156.234 251.536 158.529L219.492 171.644C213.034 172.622 208.958 175.864 206.619 180.548V180.527L173.837 231.345L165.21 277.722C165.21 277.722 202.121 239.745 213.097 240.513C214.867 240.64 216.395 241.629 217.711 243.187C227.708 266.891 225.854 300.541 225.854 300.541C225.854 328.445 225.032 309.751 252.958 309.751L255.149 315.425C279.177 317.404 285.255 315.425 302.394 309.836C302.394 309.836 320.555 230.945 310.547 198.853Z"
          fill="#D8DBEA"
        />
        <mask
          id="mask2_16930_595"
          style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="165"
          y="158"
          width="149"
          height="159"
        >
          <path
            d="M310.547 198.853C300.54 166.76 282.085 156.234 251.536 158.529L219.492 171.644C213.034 172.622 208.958 175.864 206.619 180.548V180.527L173.837 231.345L165.21 277.722C165.21 277.722 202.121 239.745 213.097 240.513C214.867 240.64 216.395 241.629 217.711 243.187C227.708 266.891 225.854 300.541 225.854 300.541C225.854 328.445 225.032 309.751 252.958 309.751L255.149 315.425C279.177 317.404 285.255 315.425 302.394 309.836C302.394 309.836 320.555 230.945 310.547 198.853Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_16930_595)">
          <path
            d="M302.533 194.264L296.855 220.42L253.497 307.268L253.076 318.951L266.654 316.846C266.654 316.846 312.066 323.709 317.038 317.288C322.01 310.868 313.551 191.875 313.551 191.875L302.522 194.253"
            fill="#D8DBEA"
          />
          <path
            d="M253.044 343.602C249.051 352.37 199.246 276.764 201.617 260.628C202.796 252.597 216.154 291.489 216.154 291.489C223.548 289.552 248.461 264.101 258.795 241.776C268.255 221.346 270.277 205.778 283.065 210.199L254.761 330.845L253.054 343.602"
            fill="#BEC0D6"
          />
        </g>
        <path
          d="M198.245 163.17C197.245 162.507 195.959 161.876 194.685 161.518L189.249 151.697C189.249 151.697 189.218 151.613 189.207 151.571L195.348 142.235C196.57 139.94 195.601 136.709 194.822 137.551L185.415 149.908C184.435 150.445 183.856 151.56 184.088 152.718L187.753 165.97C187.722 167.402 188.459 168.338 190.566 169.696"
          fill="#BEC0D6"
        />
        <path
          d="M194.653 161.918C193.652 161.255 191.429 158.929 190.165 158.571L185.667 150.445C185.667 150.445 185.636 150.361 185.625 150.319L191.766 140.983C192.988 138.688 192.019 135.457 191.24 136.299L181.833 148.656C180.853 149.193 180.274 150.309 180.506 151.466L184.171 164.718C184.14 166.15 184.877 167.086 186.984 168.444"
          fill="#BEC0D6"
        />
        <path
          d="M191.398 161.107C190.397 160.444 189.112 159.812 187.837 159.454L182.402 149.634C182.402 149.634 182.37 149.55 182.359 149.508L188.501 140.171C189.723 137.877 188.754 134.645 187.974 135.487L178.567 147.844C177.588 148.381 177.008 149.497 177.24 150.655L180.906 163.907C180.874 165.338 181.612 166.275 183.718 167.633"
          fill="#BEC0D6"
        />
        <path
          d="M242.667 147.823C242.857 142.392 249.419 134.161 249.419 134.161L252.537 107.731L232.997 100.047C232.997 100.047 224.117 95.2263 218.523 95.2158C212.919 95.2158 199.414 99.4998 199.414 99.4998L182.655 105.457C182.655 105.457 178.231 135.435 187.985 153.791C193.831 164.791 203.491 172.117 209.148 172.706C210.844 172.885 217.427 169.896 219.471 171.675C221.515 173.453 228.193 175.958 232.323 175.958C238.822 175.958 249.187 169.706 251.515 158.549L242.646 147.834L242.667 147.823Z"
          fill="#F1F2F7"
        />
        <mask
          id="mask3_16930_595"
          style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="181"
          y="95"
          width="72"
          height="81"
        >
          <path
            d="M242.667 147.823C242.857 142.392 249.419 134.161 249.419 134.161L252.537 107.731L232.997 100.047C232.997 100.047 224.117 95.2263 218.523 95.2158C212.919 95.2158 199.414 99.4998 199.414 99.4998L182.655 105.457C182.655 105.457 178.231 135.435 187.985 153.791C193.831 164.791 203.491 172.117 209.148 172.706C210.844 172.885 217.427 169.896 219.471 171.675C221.515 173.453 228.193 175.958 232.323 175.958C238.822 175.958 249.187 169.706 251.515 158.549L242.646 147.834L242.667 147.823Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask3_16930_595)">
          <path
            d="M206.536 174.675C207.979 171.001 222.242 170.043 229.384 158.77C232.207 154.307 233.313 147.139 233.313 143.898C233.313 140.656 236.083 119.057 236.083 119.057L245.796 113.394L252.548 138.993C252.548 138.993 266.527 157.107 264.757 157.644C262.987 158.181 248.566 173.485 248.566 173.485L234.23 185.042L211.402 188.274L207.515 177.032"
            fill="#C7D2EA"
          />
        </g>
        <path
          d="M250.663 98.4263C242.183 89.2057 232.049 74.3434 200.257 86.3849C200.257 86.3849 190.882 89.4478 181.665 91.4898C176.556 92.6161 173.438 100.3 177.346 104.868C176.482 106.784 175.703 109.836 175.913 114.552C176.345 124.498 181.876 128.077 181.876 128.077C181.876 128.077 180.801 120.393 181.907 113.636C182.887 107.647 187.006 106.942 189.039 107.152C189.039 107.152 198.087 107.436 205.04 103.984C205.04 103.984 221.115 99.6788 226.455 108.573C231.796 117.467 233.197 125.951 233.197 125.951C233.197 125.951 235.209 131.856 237.411 124.33C239.623 116.804 245.058 120.562 245.838 126.014C246.618 131.456 243.447 144.066 237.906 143.192C237.906 143.192 238.485 146.971 240.497 150.939C242.846 155.591 246.786 159.833 250.462 151.476C258.373 133.508 259.164 107.647 250.673 98.4263H250.663Z"
          fill="#ADB0CC"
        />
        <path
          d="M205.261 166.539L189.787 159.876C188.691 159.402 187.312 159.002 185.995 158.865L178.937 150.14C178.937 150.14 178.895 150.055 178.874 150.013L183.298 139.751C184.099 137.277 182.582 134.267 181.96 135.225L174.839 149.034C173.965 149.729 173.596 150.929 174.018 152.034L179.938 164.444C180.159 165.855 181.044 166.654 183.351 167.623C184.267 168.149 189.292 170.233 192.905 175.654L177.62 205.031L192.905 214.652L204.83 179.043C205.535 178.506 208.085 176.78 208.906 174.496C209.886 171.759 207.927 167.686 205.251 166.539H205.261Z"
          fill="#C7D2EA"
        />
        <path
          d="M202.269 194.799C197.803 218.64 194.6 230.797 181.675 261.49L165.221 277.731L158.511 249.291L197.234 191.884L202.269 194.799Z"
          fill="#448CE2"
        />
        <path
          d="M272.668 193.705L241.435 290.7C231.428 296.594 176.904 333.866 176.904 333.866C178.937 339.497 182.266 344.981 186.448 350.349C186.448 350.349 231.607 331.666 244.627 323.961C244.627 323.961 266.822 311.635 272.668 308.899C278.515 306.162 306.841 215.462 306.841 215.462C308.705 206.505 311.992 191.684 302.585 182.948C293.167 174.201 278.989 182.843 272.668 193.695V193.705Z"
          fill="#C5CAE4"
        />
        <path
          d="M145.702 251.082C151.549 239.03 184.468 186.138 184.468 186.138C190.872 188.412 196.666 191.169 201.533 194.632C201.533 194.632 181.613 253.45 174.976 265.355C168.33 277.259 157.817 286.427 147.988 280.491C139.93 275.628 139.867 263.134 145.702 251.082Z"
          fill="#5491E9"
        />
      </g>
      <g clip-path="url(#clip1_16930_595)">
        <path
          d="M57.6678 293.77L233.571 296.502C236.223 296.589 238.237 294.526 238.071 291.896L231.092 185.162C230.918 182.459 228.592 180.215 225.896 180.142L46.0878 178.464C43.4428 178.399 41.5008 180.512 41.7326 183.186L52.5373 288.896C52.7691 291.504 55.0663 293.676 57.6678 293.763V293.77Z"
          fill="#F7F7F7"
        />
        <path
          d="M56.0676 295.224L232.115 297.955C234.775 298.042 236.789 295.979 236.615 293.35L229.63 186.615C229.586 183.84 227.412 181.661 224.427 181.596L45.9224 179.917C43.7195 179.917 41.4513 180.695 41.5673 184.639L50.9298 290.35C51.1617 292.957 53.4588 295.129 56.0676 295.217V295.224Z"
          fill="#EAE5E5"
        />
        <path
          d="M196.774 184.471L73.4663 183.011"
          stroke="#D5D5D5"
          stroke-width="2.28716"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M102.737 323.728H149.781L148.368 255.814L115.744 253.634L102.737 323.728ZM121.469 277.737C121.469 273.48 124.911 270.03 129.158 270.03C133.404 270.03 136.846 273.48 136.846 277.737C136.846 281.994 133.404 285.445 129.158 285.445C124.911 285.445 121.469 281.994 121.469 277.737Z"
          fill="#DBDBDB"
        />
        <path
          d="M101.287 323.728H148.332L146.919 255.814L114.295 253.634L101.287 323.728ZM120.019 277.737C120.019 273.48 123.462 270.03 127.708 270.03C131.955 270.03 135.397 273.48 135.397 277.737C135.397 281.994 131.955 285.445 127.708 285.445C123.462 285.445 120.019 281.994 120.019 277.737Z"
          fill="#EDEBEB"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_16930_595"
        x1="136.685"
        y1="170.076"
        x2="98.2163"
        y2="212.152"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7B90FF" />
        <stop
          offset="1"
          stop-color="#5061FA"
        />
      </linearGradient>
      <clipPath id="clip0_16930_595">
        <rect
          width="273.947"
          height="280.647"
          fill="white"
          transform="translate(108.706 81.8706)"
        />
      </clipPath>
      <clipPath id="clip1_16930_595">
        <rect
          width="233.332"
          height="145.519"
          fill="white"
          transform="translate(41.5664 178.464)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
